import { motion } from "framer-motion";
import React, { FC } from "react";

type Props = {
  children?: React.ReactNode;
  title: string;
  idx: number;
  active: boolean;
};

export const Step: FC<Props> = ({ children, title, idx, active = false }) => {
  return (
    <motion.div className="mb-16" id={`step-${idx}`}>
      <div className="flex flex-row items-center">
        <div
          className={`w-12 h-12 rounded-lg rounded-br-none font-bold ${
            active ? "bg-yellow-400 text-white" : "bg-gray-200 text-gray-500 "
          } text-center text-2xl flex justify-center items-center`}
        >
          {idx}
        </div>
        <div className="flex flex-row items-center">
          <div className="ml-4 text-xl">{title}</div>
          {/* {idx === currentStep > 1 && (
            <div className="button bg-gray-400 rounded-full px-8 py-2">
              ändra
            </div>
          )} */}
        </div>
      </div>
      <div className="mt-8">{children}</div>
    </motion.div>
  );
};
